import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Boxes, Network, Database, Bot, BarChart3, Plug } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

const ICONS = [Boxes, Network, Database, Bot, BarChart3, Plug];

export default function SolutionsGrid({ compact = false }) {
  const { lang } = useLang();
  const t = HOME_I18N[lang].solutions;

  return (
    <section className={`${compact ? "py-16" : "section"} bg-white`} data-testid="solutions-section">
      <div className="container-x">
        {!compact && (
          <div className="max-w-3xl">
            <span className="eyebrow">{t.eyebrow}</span>
            <h2 className="mt-3 h2-section">
              {t.title1}<br />
              <span className="text-[#2563EB]">{t.titleAccent}</span>
            </h2>
            <p className="mt-5 body-lg max-w-2xl">{t.desc}</p>
          </div>
        )}

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {t.items.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={s.t}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
                className="group rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:border-[#2563EB]/30 hover:shadow-lg hover:-translate-y-1"
                data-testid={`solution-card-${i}`}
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#07111F] text-[#22D3EE]">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <h3 className="mt-6 font-heading text-lg font-semibold text-[#07111F]">{s.t}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#334155]">{s.d}</p>
              </motion.div>
            );
          })}
        </div>

        {!compact && (
          <div className="mt-12">
            <Link to="/kurumsal-cozumler" data-testid="solutions-services-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[#2563EB] hover:gap-3 transition-all">
              {t.link} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}
